import { useQuery } from '@tanstack/react-query';
import { gamePlanService } from '@/services/game-plan.service';
import { PlaybookChapter } from '@/types/gamePlan';

/** Loads the Owner Playbook (chapters + fragments) for the Game Plan module. */
export function useOwnerPlaybook() {
  return useQuery<PlaybookChapter[]>({
    queryKey: ['game-plan', 'playbook'],
    queryFn: () => gamePlanService.getPlaybook(),
  });
}
